<script setup lang="ts">
defineProps<{
  subtitle: string
}>()
</script>

<template>
  <div class="text-sm font-normal text-base-content/80 w-full">
    {{ subtitle }}
  </div>
</template>
